import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/logo-psn.png")